import AddBrandInformation from "../../components/SellerPortalComponents/BrandManagementTabs/AddBrandInformation/AddBrandInformation";
import ManageOrders from "../../views/SellerPortal/SellerOrders/ManageOrders/ManageOrders";
import FBMDashboard from "../../views/FBMPortal/FBMDashboard/FBMDashboard";
import ManagePlatformProducts from "../../views/FBMPortal/FBMProducts/ManagePlatformProducts/ManagePlatformProducts";
import FBM from "../../views/SellerPortal/FBM/FBM";
import SellerDashboard from "../../views/SellerPortal/SellerDashboard/SellerDashboard";
import AddProduct from "../../views/SellerPortal/SellerProducts/AddProduct/AddProduct";
import BrandManagement from "../../views/SellerPortal/SellerProducts/BrandManagement/BrandManagement";
import ManageProducts from "../../views/SellerPortal/SellerProducts/ManageProducts/ManageProducts";
import OrderFulfillment from "../../views/SellerPortal/SellerOrders/OrderFulfillment/OrderFulfillment";
import ReturnsAndRefunds from "../../views/SellerPortal/SellerOrders/ReturnsAndRefunds/ReturnsAndRefunds";
import OrderAnalytics from "../../views/SellerPortal/SellerOrders/OrderAnalytics/OrderAnalytics";
import OrderCustomization from "../../views/SellerPortal/SellerOrders/OrderCustomization/OrderCustomization";
import ManageFulfillmentSKU from "../../views/FBMPortal/FBMProducts/ManageFulfillmentSKU/ManageFulfillmentSKU";
import OrderManagement from "../../views/FBMPortal/FBMOrders/SentToWarehouse/OrderManagement/OrderManagement";
import CreateNewShipment from "../../views/FBMPortal/FBMOrders/SentToWarehouse/CreateNewShipment/CreateNewShipment";
import TrackShipment from "../../views/FBMPortal/FBMOrders/SentToWarehouse/TrackShipment/TrackShipment";
import ReceivedInventory from "../../views/FBMPortal/FBMOrders/SentToWarehouse/ReceivedInventory/ReceivedInventory";
import InventoryDiscrepancies from "../../views/FBMPortal/FBMOrders/SentToWarehouse/InventoryDiscrepancies/InventoryDiscrepancies";
import ReverseOrderManagement from "../../views/FBMPortal/FBMOrders/BackFromWarehouse/ReverseOrderManagement/ReverseOrderManagement";
import CreateReturnShipment from "../../views/FBMPortal/FBMOrders/BackFromWarehouse/CreateReturnShipment/CreateReturnShipment";
import TrackShipmentBack from "../../views/FBMPortal/FBMOrders/BackFromWarehouse/TrackShipmentBack/TrackShipmentBack";
import ReceivedInventoryBack from "../../views/FBMPortal/FBMOrders/BackFromWarehouse/ReceivedInventoryBack/ReceivedInventoryBack";
import InventoryDiscrepanciesBack from "../../views/FBMPortal/FBMOrders/BackFromWarehouse/InventoryDiscrepanciesBack/InventoryDiscrepanciesBack";
import InventoryReport from "../../views/FBMPortal/FBMReports/InventoryReport/InventoryReport";
import ExpiryDateReport from "../../views/FBMPortal/FBMReports/ExpiryDateReport/ExpiryDateReport";
import InventoryAging from "../../views/FBMPortal/FBMReports/InventoryAging/InventoryAging";
import InventoryReconciliation from "../../views/FBMPortal/FBMReports/InventoryReconciliation/InventoryReconciliation";
import FinancialReport from "../../views/FBMPortal/FBMReports/FinancialReport/FinancialReport";
import Reviews from "../../views/SellerPortal/CustomerEngage/Reviews/Reviews";
import PurchaseHistory from "../../views/SellerPortal/CustomerEngage/PurchaseHistory/PurchaseHistory";
import Campaigns from "../../views/SellerPortal/MarketingOptions/Campaigns/Campaigns";
import ViewCampaign from "../../views/SellerPortal/MarketingOptions/Campaigns/ViewCampaign/ViewCampaign";
import ProductSubmission from "../../views/SellerPortal/MarketingOptions/Campaigns/ProductSubmission/ProductSubmission";
import Coupons from "../../views/SellerPortal/MarketingOptions/Coupons/Coupons";
import Vouchers from "../../views/SellerPortal/MarketingOptions/Vouchers/Vouchers";
import VoucherDetails from "../../views/SellerPortal/MarketingOptions/Vouchers/VoucherDetails/VoucherDetails";
import FreeDelivery from "../../views/SellerPortal/MarketingOptions/FreeDelivery/FreeDelivery";
import RetailerPicks from "../../views/SellerPortal/MarketingOptions/RetailerPicks/RetailerPicks";
import PrivateTraffic from "../../views/SellerPortal/MarketingOptions/PrivateTraffic/PrivateTraffic";
import Overview from "../../views/SellerPortal/Advertisement/Overview/Overview";
import Management from "../../views/SellerPortal/Advertisement/Management/Management";
import Creation from "../../views/SellerPortal/Advertisement/Creation/Creation";
import SponsoredProducts from "../../views/SellerPortal/Advertisement/SponsoredProducts/SponsoredProducts";
import SponsoredBrands from "../../views/SellerPortal/Advertisement/SponsoredBrands/SponsoredBrands";
import SponsoredDisplay from "../../views/SellerPortal/Advertisement/SponsoredDisplay/SponsoredDisplay";
import BannerAds from "../../views/SellerPortal/Advertisement/BannerAds/BannerAds";
import AdPerformance from "../../views/SellerPortal/Advertisement/AdPerformance/AdPerformance";
import SponsoredVideoAd from "../../views/SellerPortal/Advertisement/SponsoredVideoAd/SponsoredVideoAd";
import Pricing from "../../views/SellerPortal/PricingAndFinance/Pricing/Pricing";
import FinanceOverview from "../../views/SellerPortal/PricingAndFinance/FinanceOverview/FinanceOverview";
import TransactionHistory from "../../views/SellerPortal/PricingAndFinance/TransactionHistory/TransactionHistory";
import SalesReport from "../../views/FBMPortal/FBMReports/SalesReport/SalesReport";
import FBMScheduleDropOff from "../../views/FBMPortal/FBMScheduleDropOff/FBMScheduleDropOff";
import ReportsAnalytics from "../../views/SellerPortal/ReportsAnalytics/ReportsAnalytics";
import PaymentInfo from "../../views/SellerPortal/PricingAndFinance/PaymentInfo/PaymentInfo";
import FeeBreakdown from "../../views/SellerPortal/PricingAndFinance/FeeBreakdown/FeeBreakdown";
import SellerFinancing from "../../views/SellerPortal/PricingAndFinance/SellerFinancing/SellerFinancing";
import AccountHealth from "../../views/SellerPortal/Compliance/AccountHealth/AccountHealth";
import Policies from "../../views/SellerPortal/Compliance/Policies/Policies";
import ProductAdvisory from "../../views/SellerPortal/Compliance/ProductAdvisory/ProductAdvisory";
import BusinessAdvisory from "../../views/SellerPortal/Compliance/BusinessAdvisory/BusinessAdvisory";
import Profile from "../../views/SellerPortal/Settings/Profile/Profile";
import Security from "../../views/SellerPortal/Settings/Security/Security";
import Commissions from "../../views/SellerPortal/Settings/Commissions/Commissions";
import Notification from "../../views/SellerPortal/Settings/Notification/Notification";
import User from "../../views/SellerPortal/Settings/User/User";
import ChatSetting from "../../views/SellerPortal/Settings/ChatSetting/ChatSetting";
import DocumentTemplate from "../../views/SellerPortal/OtherResources/DocumentTemplate/DocumentTemplate";
import Services from "../../views/SellerPortal/OtherResources/Services/Services";
import PackagingMaterial from "../../views/SellerPortal/OtherResources/PackagingMaterial/PackagingMaterial";
import Subscription from "../../views/SellerPortal/OtherResources/Subscription/Subscription";
import EditCouponDetails from "../../views/SellerPortal/MarketingOptions/Coupons/EditCouponDetails/EditCouponDetails";
import PersonalizedRecommendations from "../../components/SellerPortalComponents/PersonalizedRecommendations/PersonalizedRecommendations";
import StoreSetting from "../../views/SellerPortal/Settings/StoreSetting/StoreSetting";
import CreateStorePage from "../../views/SellerPortal/Settings/StoreSetting/CreateStorePage/CreateStorePage";
import CreateNewTheme from "../../views/SellerPortal/Settings/StoreSetting/CreateNewTheme/CreateNewTheme";
import CreateCustomPage from "../../views/SellerPortal/Settings/StoreSetting/CreateCustomPage/CreateCustomPage";
import StoreThemePreview from "../../views/SellerPortal/Settings/StoreThemePreview/StoreThemePreview";

const sellerRoutes = [
    {
        path: "/dashboard",
        element: <SellerDashboard />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        }
    },
    {
        path: "/products",
        // element: <UserDashboard />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        },
        children: [
            {
                path: "manage",
                element: <ManageProducts />,
            },
            {
                path: "add",
                element: <AddProduct />,
            },
            {
                path: "brand",
                element: <BrandManagement />,
            },
            {
                path: "brand/edit",
                element: <AddBrandInformation />,
            }
        ]
    },
    {
        path: '/orders',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: "manage",
                element: <ManageOrders />
            },
            {
                path: "fulfillment",
                element: <OrderFulfillment />
            },
            {
                path: "returns-and-refunds",
                element: <ReturnsAndRefunds />
            },
            {
                path: "order-analytics",
                element: <OrderAnalytics />
            },
            {
                path: "order-customization",
                element: <OrderCustomization />
            },
        ]
    },
    {
        path: "/fbmregister",
        element: <FBM />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        }
    },
    {
        path: '/customer-engage',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: "reviews",
                element: <Reviews />
            },
            {
                path: "purchase-history",
                element: <PurchaseHistory />
            },
        ]
    },
    {
        path: '/marketing-options',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: "campaigns",
                element: <Campaigns />
            },
            {
                path: "campaigns/view",
                element: <ViewCampaign />
            },
            {
                path: "campaigns/add-product",
                element: <ProductSubmission />
            },
            {
                path: 'coupons',
                element: <Coupons />
            },
            {
                path: 'edit-coupon',
                element: <EditCouponDetails />
            },
            {
                path: 'vouchers',
                element: <Vouchers />
            },
            {
                path: 'vouchers/detail',
                element: <VoucherDetails />
            },
            {
                path: 'free-delivery',
                element: <FreeDelivery />
            },
            {
                path: 'retailer-picks',
                element: <RetailerPicks />
            },
            {
                path: 'private-traffic',
                element: <PrivateTraffic />
            }
        ]
    },
    {
        path: '/advertisement',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: "overview",
                element: <Overview />
            },
            {
                path: "creation",
                element: <Creation />
            },
            {
                path: "creation/sponsored-products",
                element: <SponsoredProducts />
            },
            {
                path: "creation/sponsored-brands",
                element: <SponsoredBrands />
            },
            {
                path: "creation/sponsored-display",
                element: <SponsoredDisplay />
            },
            {
                path: "creation/sponsored-banner-ads",
                element: <BannerAds />
            },
            {
                path: "creation/sponsored-video-ad",
                element: <SponsoredVideoAd />
            },
            {
                path: "management",
                element: <Management />
            },
            {
                path: "ad-performance",
                element: <AdPerformance />
            },
        ]
    },
    {
        path: '/pricing-and-finance',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: "pricing",
                element: <Pricing />
            },
            {
                path: "overview",
                element: <FinanceOverview />
            },
            {
                path: "transaction-history",
                element: <TransactionHistory />
            },
            {
                path: 'payment-info',
                element: <PaymentInfo />
            },
            {
                path: 'fee-breakdown',
                element: <FeeBreakdown />
            },
            {
                path: 'seller-financing',
                element: <SellerFinancing />
            },
        ]
    },
    {
        path: "/analytics",
        element: <ReportsAnalytics />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: "/compliance",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "accounthealth",
                element: <AccountHealth />,
            },
            {
                path: "policies",
                element: <Policies />,
            },
            {
                path: "productadvisory",
                element: <ProductAdvisory />,
            },
            {
                path: "productadvisory/recommendations",
                element: <PersonalizedRecommendations />,
            },
            {
                path: "businessadvisory",
                element: <BusinessAdvisory />,
            },
        ]
    },
    {
        path: '/other-resources',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: 'document-template',
                element: <DocumentTemplate />
            },
            {
                path: 'services',
                element: <Services />
            },
            {
                path: 'packaging-material',
                element: <PackagingMaterial />
            },
            {
                path: 'subscription',
                element: <Subscription />
            },
        ]
    },
    {
        path: '/settings',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: 'profile',
                element: <Profile />
            },
            {
                path: 'security',
                element: <Security />
            },
            {
                path: 'commission',
                element: <Commissions />
            },
            {
                path: 'notification',
                element: <Notification />
            },
            {
                path: 'user',
                element: <User />
            },
            {
                path: 'chat-setting',
                element: <ChatSetting />
            },
            {
                path: 'store-setting',
                element: <StoreSetting />
            },
            {
                path: 'create-store-page',
                element: <CreateStorePage />
            },
            {
                path: 'create-new-theme',
                element: <CreateNewTheme />
            },
            {
                path: 'create-custom-page',
                element: <CreateCustomPage />
            },
            {
                path: 'store-theme-preview',
                element: <StoreThemePreview />
            },
        ]
    },



    // ---------------------------------- FBM Dashboard Sidebar Routes --------------------------------------
    {
        path: "/fbm/dashboard",
        element: <FBMDashboard />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        }
    },
    {
        path: "/fbm/products",
        // element: <UserDashboard />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        },
        children: [
            {
                path: "manageproducts",
                element: <ManagePlatformProducts />,
            },
            {
                path: "managesku",
                element: <ManageFulfillmentSKU />,
            },
        ]
    },
    {
        path: '/fbm/orders',
        meta: {
            layout: 'vertical'
        },
        children: [
            {
                path: "sent",
                // element: <ManageOrders />,
                children: [
                    {
                        path: "management",
                        element: <OrderManagement />
                    },
                    {
                        path: "newshipment",
                        element: <CreateNewShipment />
                    },
                    {
                        path: "trackshipment",
                        element: <TrackShipment />
                    },
                    {
                        path: "receivedinventory",
                        element: <ReceivedInventory />
                    },
                    {
                        path: "inventorydiscrepancies",
                        element: <InventoryDiscrepancies />
                    },
                ]
            },
            {
                path: "back",
                // element: <OrderFulfillment />,
                children: [
                    {
                        path: "reverseorder",
                        element: <ReverseOrderManagement />
                    },
                    {
                        path: "returnshipment",
                        element: <CreateReturnShipment />
                    },
                    {
                        path: "trackshipment",
                        element: <TrackShipmentBack />
                    },
                    {
                        path: "receivedinventory",
                        element: <ReceivedInventoryBack />
                    },
                    {
                        path: "inventorydiscrepancies",
                        element: <InventoryDiscrepanciesBack />
                    },
                ]
            },
        ]
    },
    {
        path: "/fbm/schedule",
        element: <FBMScheduleDropOff />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        },
    },
    {
        path: "/fbm/reports",
        // element: <UserDashboard />,
        meta: {
            layout: 'vertical',
            // publicRoute: true,
            // restricted: true
        },
        children: [
            {
                path: "sales",
                element: <SalesReport />,
            },
            {
                path: "inventory",
                element: <InventoryReport />,
            },
            {
                path: "expirydate",
                element: <ExpiryDateReport />,
            },
            {
                path: "inventoryaging",
                element: <InventoryAging />,
            },
            {
                path: "inventoryreconciliation",
                element: <InventoryReconciliation />,
            },
            {
                path: "financial",
                element: <FinancialReport />,
            },
        ]
    },
];

export default sellerRoutes;